/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const TransactionService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(url, filterByCode, select) {
    const requestScreenData = {
      url: "api/" + url,
      top: "1",
      filter: filterByCode,
    };

    if (select) requestScreenData.select = select;

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async saveTransaction(payload) {
    var url = "api/Save_Invoice";

    return await ApiService.post(url, payload);
  },
  async saveInvoiceCredit(payload) {
    var url = "api/Save_InvoiceCredit";

    return await ApiService.post(url, payload);
  },

  //   async saveSupplier(mode, payload) {
  //     var url = "api/Save_Supplier";

  //     if (mode == "create") {
  //       return await ApiService.post(url, payload, "String");
  //     } else {
  //       return await ApiService.put(url, payload.Code, payload, "String");
  //     }
  //   },
};

export { TransactionService };
